// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row-bg[data-v-09db8da6] {\n  background: #fff;\n  margin-bottom: 15px;\n  padding: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
